var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-card',[_c('vs-chip',{attrs:{"transparent":"","color":"danger"}},[_c('vs-avatar'),_vm._v("\n            Total visitas "+_vm._s(_vm.visitasgdocente)+"\n         ")],1),_c('indreportedocentepastel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }